export const importantTagLevels = [ 'error', 'warning' ]

export const reserveAdjustmentReasons = [
  'clientCredit',
  'brokerClaim',
  'directPaymentByClient',
  'fee',
  'nonFactoredPayment',
  'overadvance',
  'releaseOfFunds',
  'releaseOfFundsTo3rdParty',
  'transferFromPositive',
  'transferToPositive',
  'writeOff',
]
